import { usePrototypeHostViewModel } from '../view-model/PrototypeHost.viewModel';
import { frame } from './PrototypeHost.view.css';

type PrototypeHostViewProps = { creatorId: number };

export const PrototypeHostView = (p: PrototypeHostViewProps) => {
  const vm = usePrototypeHostViewModel({ creatorId: p.creatorId });

  return (
    <iframe
      key={p.creatorId}
      ref={vm.frameRef}
      src={vm.frameSrc}
      title="Exercise catalog preview"
      className={frame}
    />
  );
};
